import { StoreCommonService } from './../../../../../services/store/store-common.service';
import { LoyaltyChannelService } from './../../../../../services/loyalty/loyalty-channel.service';
import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from "@angular/core";
import {SelectItem} from "primeng/api";


@Component({
  selector: 'kv-card-domiciliation',
  styles: [".btnDisabled  {opacity: .3;}"],
  template: `  
    <div class="ui-dialog-content ui-g-12">
      <div [kv-form-element]="{label: 'card.domiciliation_current_store', md: '12'}">
        {{currentStore.code}} - {{currentStore.name}}
      </div>
      <div [kv-form-element]="{label: 'card.domiciliation_select_channel', md: '12'}">
        <p-dropdown [(ngModel)]="selectedChannel" (onChange)="getStoresByChannel()" [options]="channels" [filter]="true" placeholder="Seleziona..."></p-dropdown>
      </div>
      <div [kv-form-element]="{label: 'card.domiciliation_select_store', md: '12'}">
        <p-dropdown [(ngModel)]="selectedStore" [options]="filteredStoresListItem" [filter]="true" placeholder="Seleziona..."></p-dropdown>
      </div>
    </div>
    <div class="ui-dialog-footer">
      <button type="button" [ngClass]="{'btnDisabled' : !selectedStore || !selectedChannel}" [disabled]="!selectedStore || !selectedChannel" pButton class="ui-button-success btnDelete" icon="fa fa-retweet" iconPos="left" (click)="this.onSave.emit(this.selectedStore)" label="{{'common.save' | translate}}"></button>
      <button type="button" pButton class="ui-button-danger btnDelete" icon="fa fa-close" iconPos="left" (click)="this.onCancel.emit()" label="{{'common.cancel' | translate}}"></button>
    </div>
  `
})
export class CardDomiciliationComponent implements OnChanges {

  @Input() card;
  @Input() filteredStores;
  @Input() currentStore;

  @Output() onCancel: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSave: EventEmitter<any> = new EventEmitter<any>();

  filteredStoresListItem: SelectItem[] = [];
  selectedStore: any;
  selectedChannel: any;
  channels: SelectItem[] = [];

  constructor(
    private loyaltyChannelService: LoyaltyChannelService,
    private storeService: StoreCommonService
  ) {}

  ngOnInit(): void {
    this.loyaltyChannelService.getAllChannels().subscribe(channels => {
      channels.forEach(channel => this.channels.push({label: channel.description ,value: channel.id}));
      this.selectedChannel = this.card.channel_id;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["filteredStores"] && changes["filteredStores"].currentValue) {
      this.updateStores(changes["filteredStores"].currentValue);
    }
  }

  getStoresByChannel() {
    this.storeService.getListFilteredByChannel(this.selectedChannel).subscribe(res => this.updateStores(res));
  }

  updateStores(stores: any) {
    this.filteredStoresListItem = []
    stores.forEach(s => {
      this.filteredStoresListItem.push({
        label: `${s.code} - ${s.name}`,
        value: {code: s.code, id : s.id, name: s.name}
      })
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/loyaltyinfo/components/card-domiciliation.component.ts